
<section class="footer__demo-section">
  <div class="footer__demo-section-container">
    <h2 l10nTranslate>Ready To Get Started</h2>
    <p [innerHTML]="'Request a demo today to see how we can enable your GRC transformation journey'" l10nTranslate></p>
    <button class="footer__btn-book-demo" [routerLink]="['/contact-us']" l10nTranslate>Request a demo</button>

  </div>

</section>

<footer class="footer">
    <div class="footer__container">

        <section class="footer__holder">
<div class="footer__holder-lists">
    <div class="footer__company-info">
        <a [routerLink]="['/']" class="footer__logo">
            <img src="../../../../assets/svg/solidrange-center-white.svg">
        </a>

        <p class="footer__company-info-description" l10nTranslate>Automate your GRC and human risk management</p>

        <div class="footer__made-in-ksa">
            <img src="../../../../assets/svg/Layer_1.svg">
            <div class="footer__made-in-ksa-text" l10nTranslate>Proudly Made in Saudi Arabia</div>
        </div>
    </div>

    <div class="footer__list">

        <ul>
            <p l10nTranslate>Products</p>
            <li><a [routerLink]="['/products-grc']" l10nTranslate>GRC Automation</a></li>
            <li><a [routerLink]="['/products-awareness']" l10nTranslate>Security Awarness</a></li>
            <li><a [routerLink]="['/products-phishing-simulation']" l10nTranslate>Phishing Simulation2</a></li>
            

        </ul>
    </div>
    <div class="footer__list">

        <ul>
            <p l10nTranslate>Services</p>
            <li><a [routerLink]="['/services/Consultations']" l10nTranslate>GRC Consulting</a></li>
            <li><a [routerLink]="['/services/Awareness']" l10nTranslate>Managed Awareness</a></li>
            <li><a [routerLink]="['/services/Compliance']" l10nTranslate>Certification</a></li>
        </ul>
    </div>
    <div class="footer__list">
        <ul>
            <p l10nTranslate>Company</p>
            <li><a [routerLink]="['/about-us']" l10nTranslate>About us</a></li>
            <!-- <li><a [routerLink]="['/blogs']" l10nTranslate>News Blogs</a></li> -->
            <li><a [routerLink]="['/partner']" l10nTranslate>Partners</a></li>
            <li><a [routerLink]="['/contact-us']" l10nTranslate>Contact us</a></li>
        </ul>
    </div>
</div>

<div class="footer__company-info-address">
    <p class="footer__company-info-address-riyadh" l10nTranslate>Riyadh</p>
    <p class="footer__company-info-address-airport" l10nTranslate>Riyadh Front, Airport Road</p>
    <p class="footer__company-info-address-airport" l10nTranslate>Riyadh 13413,Saudi Arabia</p>

</div>
<br>

        </section>
        <div class="footer__copyright">
            <p l10nTranslate>
                <span l10nTranslate>Copyrights</span>
                <span l10nTranslate class="footer__copyright-year">{{currentYear}} Solidrange, Ltd.</span>
                <span l10nTranslate>All Rights Reserved</span>
            </p>
            <div class="footer__copyright-social">
                <ul>
                    <li> <a target="_blank" [href]="'https://www.linkedin.com/company/solidrange/'">
                            <img class="linkedin" src="../../../../assets/images/linkedin.svg">
                        </a>
                    </li>
                    <li>

                        <a target="_blank" [href]="'https://wa.me/+966550722030'">
                            <img class="whatsapp" src="../../../../assets/images/whatsapp.svg">
                        </a>
                    </li>

                    <!-- <li> <a href="tel:+9660558188338">
                            <img class="phone_logo" src="../../../../assets/images/telephone.svg">

                        </a></li>
                    <li>
                        <a href="tel:+9660558188338">(+966) 0558188338</a>

                    </li> -->
                </ul>


            </div>

            <div>
                <ul>
                    <li><a [routerLink]="['/terms-and-conditions']" l10nTranslate>Terms of Use</a></li>
                    <li><a [routerLink]="['/privacy-policy']" l10nTranslate>Privacy Policy</a></li>
                    <li><a [routerLink]="['/cookie-policy']" l10nTranslate>Cookie Policy</a></li>
                </ul>

            </div>
        </div>


    </div>


</footer>